import React, { useState } from "react";
import { Image } from "react-bootstrap";
import { RegisterCompany } from "../../types";
import { BarLoader } from "react-spinners";

interface RegisterHereProps {
  formData: RegisterCompany;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  registerCompany: (e: React.FormEvent<HTMLFormElement>) => void;
  loading: boolean;
}

const RegisterHere: React.FC<RegisterHereProps> = ({
  formData,
  onChange,
  registerCompany,
  loading,
}) => {
  //password visibility
  const togglePassword = () => {
    const password = document.getElementById("password") as HTMLInputElement;
    const eyes = document.getElementById("togglePassword");

    if (password.type === "password") {
      password.type = "text";
      if (eyes) {
        eyes.className = "bi bi-eye";
      }
    } else {
      password.type = "password";
      if (eyes) {
        eyes.className = "bi bi-eye-slash";
      }
    }
  };

  return (
    <section>
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ marginTop: "5%" }}
      >
        <div className="card w-50 shadow-lg p-3 mb-5 bg-body-tertiary rounded border-0">
          <div className="card-body py-5">
            <div className="d-flex justify-content-center mb-3">
              <img
                src="/images/logo.png"
                className="img-thumbnail"
                alt="Logo"
              />
            </div>
            <h3 className="text-center fw-bold">Sign Up</h3>

            <div className="form-group mb-4">
              <label className="form-label">First Name</label>
              <input
                type="text"
                className="form-control p-3 rounded-0"
                name="first_name"
                placeholder="First Name"
                value={formData.first_name}
                onChange={onChange}
              />
            </div>

            <div className="form-group mb-4">
              <label className="form-label">Last Name</label>
              <input
                type="text"
                className="form-control p-3 rounded-0"
                name="last_name"
                placeholder="Last Name"
                value={formData.last_name}
                onChange={onChange}
              />
            </div>

            <div className="form-group mb-4">
              <label className="form-label">Company Name</label>
              <input
                type="text"
                className="form-control p-3 rounded-0"
                name="company_name"
                placeholder="Company Name"
                value={formData.company_name}
                onChange={onChange}
              />
            </div>

            <div className="form-group mb-4">
              <label className="form-label">Email Address</label>
              <input
                type="email"
                className="form-control p-3 rounded-0"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={onChange}
              />
            </div>

            <div className="form-group mb-4">
              <label className="form-label">Password</label>
              <div className="input-group">
                <input
                  type="password"
                  className="form-control p-3 rounded-0"
                  placeholder="Password"
                  name="password"
                  id="password"
                  value={formData.password}
                  onChange={onChange}
                />
                <span className="input-group-text">
                  <i
                    className="bi bi-eye-slash"
                    id="togglePassword"
                    onClick={togglePassword}
                  ></i>
                </span>
              </div>
            </div>

            <div className="form-group mb-4">
              <label className="form-label">Confirm Password</label>
              <div className="input-group">
                <input
                  type="password"
                  className="form-control p-3 rounded-0"
                  placeholder="Confirm Password"
                  name="confirmPassword"
                  id="password1"
                  value={formData.confirmPassword}
                  onChange={onChange}
                />
              </div>
            </div>

            <div className="form-group mt-3">
              {loading && loading ? (
                <BarLoader
                  color="#073367"
                  loading={loading}
                  width={150}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              ) : (
                <button
                  className="btn btn-primary w-100 p-3"
                  onClick={(e) =>
                    registerCompany(
                      e as unknown as React.FormEvent<HTMLFormElement>
                    )
                  }
                >
                  <h4>Sign Up</h4>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegisterHere;
